import { Button, useDisclosure } from "@chakra-ui/react";
import { RiAddCircleLine } from "react-icons/ri";
import { AddGuardiansDialog } from "./AddGuardiansDialog";
import { StudentAddress } from "./useAddGuardiansToStudent";

interface AddGuardiansButtonProps {
  organizationId: string;
  studentId: string;
  studentName: string;
  studentAddress: StudentAddress;
  excludeIds: string[];
}

export function AddGuardiansButton({
  organizationId,
  studentId,
  studentName,
  studentAddress,
  excludeIds,
}: AddGuardiansButtonProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        aria-label="Add parent/guardian"
        leftIcon={<RiAddCircleLine />}
        variant="outline"
        colorScheme="gray"
        onClick={onOpen}
      >
        Add parent/guardian
      </Button>
      {/* Remount per open so staged entries reset. */}
      <AddGuardiansDialog
        key={isOpen ? "open" : "closed"}
        isOpen={isOpen}
        onClose={onClose}
        organizationId={organizationId}
        studentId={studentId}
        studentName={studentName}
        studentAddress={studentAddress}
        excludeIds={excludeIds}
      />
    </>
  );
}
